<template>
  <b-modal
    ref="shortcutkey"
    id="shortcutkey"
    size="lg"
    title="Keyboard shortcuts [ SHIFT + ? ]"
    body-class="bg-white"
    :hide-footer="true"
  >
    <b-row>
      <div style="    padding-left: 35px;">
        <b-card class="content shortcut-keys">
          <h5 style="text-align: center;margin-top: -22px;">Index Actions</h5>
          <div style="padding-top: 10px;">
            <p>
              Customer
              <span class="label label-info key-code pull-right">c</span>

              <span class="label label-primary pull-right">+</span>
              <span class="label label-info pull-right">shift</span>
            </p>
            <p>
              Product
              <span class="label label-info key-code pull-right">p</span>
              <span class="label label-primary pull-right">+</span>
              <span class="label label-info pull-right">shift</span>
            </p>
            <p>
              Quotation
              <span class="label label-info key-code pull-right">q</span>
              <span class="label label-primary pull-right">+</span>
              <span class="label label-info pull-right">shift</span>
            </p>

            <p>
              Retainer Invoice
              <span class="label label-info key-code pull-right">r</span>
              <span class="label label-primary pull-right">+</span>
              <span class="label label-info pull-right">shift</span>
            </p>
            <p>
              Invoice
              <span class="label label-info key-code pull-right">i</span>
              <span class="label label-primary pull-right">+</span>
              <span class="label label-info pull-right">shift</span>
            </p>

            <p>
              Recurring Invoice
              <span class="label label-info key-code pull-right">h</span>
              <span class="label label-primary pull-right">+</span>
              <span class="label label-info pull-right">shift</span>
            </p>
            <p>
              Payments Received
              <span class="label label-info key-code pull-right">t</span>
              <span class="label label-primary pull-right">+</span>
              <span class="label label-info pull-right">shift</span>
            </p>
            <p>
              Customer advance
              <span class="label label-info key-code pull-right">a</span>
              <span class="label label-primary pull-right">+</span>
              <span class="label label-info pull-right">shift</span>
            </p>
            <p>
              Credit note
              <span class="label label-info key-code pull-right">n</span>
              <span class="label label-primary pull-right">+</span>
              <span class="label label-info pull-right">shift</span>
            </p>
            <p>
              GST Filing
              <span class="label label-info key-code pull-right">f</span>
              <span class="label label-primary pull-right">+</span>
              <span class="label label-info pull-right">shift</span>
            </p>
            <p>
              Reports
              <span class="label label-info key-code pull-right">g</span>
              <span class="label label-primary pull-right">+</span>
              <span class="label label-info pull-right">shift</span>
            </p>
          </div>
        </b-card>
      </div>
      <div style="padding-left:35px;">
        <b-card class="content shortcut-keys">
          <h5 style="text-align: center; margin-top: -22px;
 ">Create Actions</h5>
          <div style="padding-top: 10px;">
            <p>
              Customer
              <span class="label label-info key-code pull-right">c</span>
            </p>
            <p>
              Product
              <span class="label label-info key-code pull-right">p</span>
            </p>
            <p>
              Quotation
              <span class="label label-info key-code pull-right">q</span>
            </p>
            <p>
              Retainer Invoice
              <span class="label label-info key-code pull-right">r</span>
            </p>
            <p>
              Invoice
              <span class="label label-info key-code pull-right">i</span>
            </p>
            <p>
              Recurring Invoice
              <span class="label label-info key-code pull-right">h</span>
            </p>
            <p>
              Payments Received
              <span class="label label-info key-code pull-right">t</span>
            </p>
            <p>
              Customer advance
              <span class="label label-info key-code pull-right">a</span>
            </p>
            <p>
              Credit note
              <span class="label label-info key-code pull-right">n</span>
            </p>
            <p>
              User Role
              <span class="label label-info key-code pull-right">u</span>
            </p>
            <h5 style="text-align: center;
  ">Settings Actions</h5>
            <p style="padding-top:6px">
              User Themes
              <span class="label label-info key-code pull-right">z</span>
              <span class="label label-primary pull-right">+</span>
              <span class="label label-info pull-right">shift</span>
            </p>
            <p>
              User roles
              <span class="label label-info key-code pull-right">u</span>
              <span class="label label-primary pull-right">+</span>
              <span class="label label-info pull-right">shift</span>
            </p>
          </div>
        </b-card>
      </div>
    </b-row>
  </b-modal>
</template>

<script>
export default {};
</script>

<style scoped>
.content {
  height: 480px;
  width: 350px;
}
.card {
  border-radius: 0 !important;
  box-shadow: 0 0 15px 2px rgba(0, 0, 0, 0.07) !important;
}

.shortcut-keys .label-info {
  background-color: #03a9f4;
  width: 40px;
  text-align: center;
}
.shortcut-keys .label {
  border-radius: 3px;
  font-weight: 600;
  color: #fff;
}
.shortcut-keys .label-primary {
  background-color: #edeff1;
  font-weight: 600;
  color: #000;
  width: 18px;
  border-radius: 3px;
  text-align: center;
}

.shortcut-keys .key-code {
  width: 20px !important;
}
</style>
